
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as T from '@/types'
import S from '@/store'
import config from '@/config'

import { 
    UiIcon,
    UiFormattedText,
    UiList,
    UiListItem,
} from '@hubsolv/hubsolv-ui'

import AppWordmark from '@/components/app/AppWordmark.vue'

@Component({
    components: {
        AppWordmark,
        UiFormattedText,
        UiIcon,
        UiList,
        UiListItem,
    },
})
export default class AppReleaseInfo extends Vue {
    
    ////////////////////////////////////////////////////////////////
    // computed → features
    ////////////////////////////////////////////////////////////////

    get features () {
        return [
            {
                icon: 'file',
                name: 'Post case documents from HubSolv',
                isAvailable: true,
            },
            {
                icon: 'download',
                name: 'Securely download up to 10 files at a time',
                isAvailable: true,
            },
            {
                icon: 'file-search',
                name: 'Search and filter files by case, creditor and source',
                isAvailable: true,
            },
            {
                icon: 'bell',
                name: 'Daily email summary of your new documents and reports',
                isAvailable: true,
            },
            {
                icon: 'upload',
                name: 'Upload POD and proxy forms',
                isAvailable: true,
                comingSoon: true,
            },
            {
                icon: 'vote',
                name: 'Submit votes, claim amounts and modifications',
                isAvailable: true,
                comingSoon: true,
            },
            {
                icon: 'earth',
                name: 'An open API to integrate with your own systems',
                isAvailable: true,
                comingSoon: true,
            },
        ]
    }

    get email () {
        return config.SUPPORT.SUPPORT_EMAIL_ADDRESS
    }

}
